import { createSlice } from "@reduxjs/toolkit";
import { addressDetailsAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addressDetailsSlice = createSlice({
  name: "addressDetails",
  initialState: data,
  reducers: {
   addressDetailsSlice(state) {
      state.isLoading = true;
    },
   addressDetailsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addressDetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addressDetailsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const addressDetailsHandler: any = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addressDetailsAction.addressDetailsSlice());
    const response: any = await addressDetailsAPI(data);
    
    dispatch(addressDetailsAction.addressDetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(addressDetailsAction.addressDetailsSliceFailure(e?.response?.data));
  }
};

export default addressDetailsSlice.reducer;
export const addressDetailsAction = addressDetailsSlice.actions;